import { useApi } from "utils"
import toast from "react-hot-toast"

type SaveBudgetPayload = {
  budget_id?: number|null
  code_budget: string
  year: number
  budget: string
  location_id?: number | null
}

export function useSaveFinanceBudget() {
  const api = useApi()

  const saveBudget = async ({
    budget_id,
    code_budget,
    year,
    budget,
    location_id
  }: SaveBudgetPayload) => {

    const payload: any = {
      code_budget,
      year,
      budget
    }

    if (location_id != null) {
      payload.location_id = location_id
    }

    try {
      //  Tentukan method & URL
      const isUpdate = Boolean(budget_id)

      const url = isUpdate
        ? `/analytic/budget-nalytic/${budget_id}`
        : `/analytic/budget-analytic`

      const response = isUpdate
        ? await api.put(url, payload)
        : await api.post(url, payload)

      const data = response.data

      // 🔥 Backend kirim responseStatus di body
      if (data?.responseStatus !== 200 && data?.responseStatus !== 201) {
        const message =
          data?.payload?.[0]?.message ??
          data?.message ??
          "Failed to save budget"

        toast.error(message)
        return null
      }

      toast.success(
        isUpdate
          ? "Budget updated successfully"
          : "Budget created successfully"
      )

      return data.payload ?? null

    } catch (err: any) {
      const response = err?.response?.data

      const message =
        response?.payload?.[0]?.message ??
        response?.message ??
        "Failed to save budget"

      toast.error(message)
      return null
    }
  }

  return { saveBudget }
}